const React = require('react');
const Tooltip = require('@material-ui/core/Tooltip').default;
const ClipboardText = require('../ClipboardText/A');
const CopyIcon = require('../../icons/Copy');


module.exports = (props) => {
  const {
    children,
  } = props;
  const title = props.title || children || '';
  const value = props.value || title;

  return (
    <div className={'layoutRow fhaC fvaC wmax ' + (props.className || '')}>
      <div className="rlv wmax">
        <Tooltip
          title={<div
            className="hmax50vh-50 ov mh-8 mv-4 ph8 pv4 bgF c0 bs b1 bcC r3"
          >{title}</div>}
          placement={props.placement || 'top'}
        >
          <div className="rlv ws tov ov z2 w lh130% TooltipB_Inner">
            {children}
          </div>
        </Tooltip>
        {
          value ? (
            <div className="rlv z-1 o0 dn (z3|o100)<2:h">
              <div className="abs slt wmin layoutRow fhaC fvaC">
                <ClipboardText
                  text={value}
                  className="layoutRow fhaC fvaC bs b1 bcC r5 sq30 ov bgF mhA"
                >
                  <CopyIcon className="w19 c0 o80"/>
                </ClipboardText>
              </div>
            </div>
          ) : null
        }
      </div>
    </div>
  );
};
